// src/components/pages/CourtyardCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // adjust path if needed

export default function CourtyardCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 1.jpg`, alt: 'Courtyard 1' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 5.jpg`, alt: 'Courtyard 5' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 6.jpg`, alt: 'Courtyard 6' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 7.jpg`, alt: 'Courtyard 7' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 9.jpg`, alt: 'Courtyard 9' },
    ],
    []
  );

  return (
    <CrossfadeCarousel slides={slides} aspectRatio="3/2" delay={5000} />
  );
}
